/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

const styles = {
  itemContentPanelContainer: css`
    background-color: var(--cds-color-neutral-background-primary);
    position: relative;
    width: 100%;
    height: 100%;
  `,
};

type Props = {
  children?: React.ReactNode;
};

const MiddlePanel = ({ children }: Props) => {
  return <div css={styles.itemContentPanelContainer}>{children}</div>;
};

export default MiddlePanel;
